// ========================================
// MOTO CRAFT - EASY EDIT CONFIGURATION
// ========================================
// Edit all website content here - No coding needed!
// Just change the text, numbers, and URLs below

export const siteConfig = {
  // ========== BUSINESS INFO ==========
  businessName: "Moto Craft",
  tagline: "Luxury Car Service & Repair Specialists in Khan Market, New Delhi",
  description: "Premium Care for Mercedes • BMW • Audi • Jaguar • Land Rover • Volvo",
  domain: "motocraftindia.com",
  established: "1960",
  siteUrl: "https://motocraftindia.com",
  
  // ========== CONTACT INFO ==========
  contact: {
    phone: "+919811770078",
    whatsapp: "+919811770078",
    whatsappMessage: "Hello Moto Craft, I would like to book a service",
    email: "info@motocraftindia.com",
    address: {
      line1: "39, Prithviraj Lane, Prithviraj Market",
      line2: "Khan Market, Rabindra Nagar",
      city: "New Delhi",
      pincode: "110003",
      state: "Delhi",
      country: "India"
    },
    mapEmbed: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3504.0447842167565!2d77.22309207549654!3d28.600406975685735!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce2e9ce5202e9%3A0xa4fe91302c48f2f9!2sMoto%20Craft!5e0!3m2!1sen!2sin!4v1709457123456!5m2!1sen!2sin",
    coordinates: {
      latitude: "28.600407",
      longitude: "77.225667"
    }
  },
  
  // ========== BUSINESS HOURS ==========
  hours: "Monday – Saturday | 10:00 AM – 7:00 PM",
  hoursDetailed: {
    monday: { open: "10:00", close: "19:00", closed: false },
    tuesday: { open: "10:00", close: "19:00", closed: false },
    wednesday: { open: "10:00", close: "19:00", closed: false },
    thursday: { open: "10:00", close: "19:00", closed: false },
    friday: { open: "10:00", close: "19:00", closed: false },
    saturday: { open: "10:00", close: "19:00", closed: false },
    sunday: { closed: true }
  },
  specialNotes: ["Walk-ins welcome", "Sunday closed"],
  
  // ========== HERO SECTION ==========
  hero: {
    title: "Moto Craft",
    subtitle: "Luxury Car Service & Repair Specialists in Khan Market, New Delhi",
    specialization: "Premium Care for Mercedes • BMW • Audi • Jaguar • Land Rover • Volvo",
    location: "Khan Market, New Delhi",
    backgroundImage: "https://images.pexels.com/photos/6969034/pexels-photo-6969034.jpeg",
    stats: [
      { label: 'Established', value: '1960' },
      { label: 'Location', value: 'Khan Market' },
      { label: 'Brands Serviced', value: '7+' },
      { label: 'Walk-ins Welcome', value: 'Yes' }
    ]
  },
  
  // ========== ABOUT SECTION ==========
  about: {
    title: "About Moto Craft",
    description: [
      "Located in the heart of Khan Market, New Delhi, Moto Craft is a premium luxury car repair and service workshop specializing in European and German vehicles.",
      "We provide dealership-level expertise using genuine OEM parts, advanced diagnostic systems, and manufacturer-recommended oils — without dealership pricing.",
      "Our mission is simple: Deliver precision, transparency, and performance for every luxury vehicle we service."
    ]
  },
  
  // ========== SERVICES (ADD/EDIT/REMOVE SERVICES) ==========
  services: [
    {
      title: "Engine Diagnostics & Repair",
      description: "Advanced computerized diagnostics for Mercedes, BMW, Audi & more.",
      icon: "wrench",
      slug: "diagnostics"
    },
    {
      title: "Annual Maintenance Service",
      description: "Complete service packages using genuine oils & OEM filters.",
      icon: "settings",
      slug: "maintenance"
    },
    {
      title: "Air Suspension Repair",
      description: "Specialists in BMW & Mercedes air suspension replacement and repair.",
      icon: "gauge",
      slug: "air-suspension"
    },
    {
      title: "DPF Cleaning & Replacement",
      description: "Proper diagnosis and repair of Diesel Particulate Filter issues.",
      icon: "filter",
      slug: "dpf"
    },
    {
      title: "AC & Cooling System Repair",
      description: "Evaporator coil replacement, coolant leak diagnosis, and performance restoration.",
      icon: "snowflake",
      slug: "ac-cooling"
    },
    {
      title: "Brake & Suspension Work",
      description: "Brake pads, discs, shock absorbers & complete suspension systems.",
      icon: "disc",
      slug: "brakes"
    },
    {
      title: "Automatic Transmission Repair",
      description: "Expert transmission diagnostics, repair and maintenance.",
      icon: "settings",
      slug: "transmission"
    },
    {
      title: "Denting & Painting",
      description: "Premium finish dent repair & luxury car paint restoration.",
      icon: "paintbrush",
      slug: "denting-painting"
    },
    {
      title: "Vehicle Restoration",
      description: "Complete restoration services for classic and luxury vehicles.",
      icon: "sparkles",
      slug: "restoration"
    },
    {
      title: "Custom Modifications",
      description: "Performance upgrades and luxury customization solutions.",
      icon: "sparkles",
      slug: "custom-modifications"
    },
    {
      title: "Wheelchair Accessible Conversions",
      description: "Mobility solutions and wheelchair-accessible vehicle conversions.",
      icon: "wrench",
      slug: "wheelchair-conversions"
    }
  ],
  
  // ========== BRANDS WE SERVICE (ADD/EDIT BRANDS) ==========
  brands: [
    { name: "Mercedes-Benz", logo: "car" },
    { name: "BMW", logo: "car" },
    { name: "Audi", logo: "car" },
    { name: "Jaguar", logo: "car" },
    { name: "Land Rover", logo: "car" },
    { name: "Volvo", logo: "car" },
    { name: "Porsche", logo: "car" }
  ],
  
  // ========== WHY CHOOSE US ==========
  features: [
    {
      title: "Luxury Car Specialists",
      description: "Expert technicians trained in European car systems",
      icon: "award"
    },
    {
      title: "Genuine Parts & Oils",
      description: "Only OEM parts and manufacturer-recommended oils",
      icon: "checkCircle"
    },
    {
      title: "Advanced Diagnostics",
      description: "State-of-the-art computerized diagnostic equipment",
      icon: "cpu"
    },
    {
      title: "Transparent Pricing",
      description: "Dealership quality without dealership prices",
      icon: "badge"
    },
    {
      title: "Prime Location",
      description: "Conveniently located in Khan Market",
      icon: "mapPin"
    },
    {
      title: "Experienced Team",
      description: "Decades of combined European car expertise",
      icon: "users"
    }
  ],
  
  // ========== GALLERY IMAGES (YOUR REAL WORK FROM INSTAGRAM) ==========
  gallery: [
    {
      url: "/gallery/image1.jpg",
      title: "Luxury Car Service",
      category: "service",
      instagramUrl: "https://www.instagram.com/p/CTenbTLJ-aB/"
    },
    {
      url: "/gallery/image2.jpg",
      title: "Expert Repair Work",
      category: "service",
      instagramUrl: "https://www.instagram.com/p/Cg6jB07JxNB/"
    },
    {
      url: "/gallery/image3.jpg",
      title: "Premium Workshop",
      category: "facility",
      instagramUrl: "https://www.instagram.com/p/CTrcdVzqVIK/"
    },
    {
      url: "/gallery/image4.jpg",
      title: "Luxury Car Care",
      category: "cars",
      instagramUrl: "https://www.instagram.com/p/DUVeTwOErmF/"
    },
    {
      url: "/gallery/image5.jpg",
      title: "Professional Service",
      category: "service",
      instagramUrl: "https://www.instagram.com/p/DLKYs3lSFqP/"
    },
    {
      url: "/gallery/image6.jpg",
      title: "High-End Repairs",
      category: "cars",
      instagramUrl: "https://www.instagram.com/p/DH-_k5uSzPM/"
    },
    {
      url: "/gallery/image7.jpg",
      title: "Expert Technicians",
      category: "service",
      instagramUrl: "https://www.instagram.com/p/DHsrFxjoE4u/"
    },
    {
      url: "/gallery/image8.jpg",
      title: "Workshop Excellence",
      category: "facility",
      instagramUrl: "https://www.instagram.com/p/C1o0blqyHV5/"
    },
    {
      url: "/gallery/image9.jpg",
      title: "Precision Work",
      category: "cars",
      instagramUrl: "https://www.instagram.com/p/CyiejgXyDHe/"
    },
    {
      url: "/gallery/image10.jpg",
      title: "Quality Service",
      category: "service",
      instagramUrl: "https://www.instagram.com/p/CqLHTXdyCGJ/"
    }
  ],
  
  // ========== SOCIAL MEDIA ==========
  social: {
    instagram: "https://www.instagram.com/motocraft.khanmarket/",
    facebook: "#", // Add your Facebook URL
    twitter: "#"   // Add your Twitter URL
  },
  
  // ========== SEO & META ==========
  seo: {
    keywords: [
      "Luxury car service in Delhi",
      "Mercedes repair in Khan Market",
      "BMW workshop in Delhi",
      "Audi DPF repair Delhi",
      "Jaguar service center Delhi",
      "Land Rover repair specialist Delhi",
      "Volvo car repair New Delhi"
    ]
  }
};

export default siteConfig;
